<template>
  <div class="container pdf-report-care">
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div v-show="errors.length == 0">
        <div class="text-right mb-2">
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>

        <table v-if="type_report == 'analytical'" class="table">
          <thead>
            <tr>
              <td>
                <div class="header-space">
                  <div v-if="resident.id" class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../../../assets/user.png')"
                      />
                      <ResidentDataPrintDefault :resident_id="resident.id" />
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="content">
                  <div
                    v-for="care in cares"
                    :key="care.care.id"
                    class="border mb-3 mt-3 p-2"
                    style="page-break-inside: avoid !important"
                  >
                    <!-- ABRE SINAIS VITAIS -->
                    <h6 class="worksansr text-center text-eighteen">
                      {{ formatDate(care.care.created_at, false) }}
                    </h6>
                    <div
                      v-if="
                        care.care_vital_signs &&
                        care.care_vital_signs.length > 0
                      "
                      class="text-center"
                    >
                      <strong>SINAIS VITAIS</strong>
                    </div>
                    <div
                      v-for="(item, key) in care.care_vital_signs"
                      :key="`${key}-${generateId()}`"
                      style="page-break-inside: avoid !important"
                    >
                      <div
                        v-for="(item, key) in item.vital_signs"
                        :key="`${key}-${generateId()}`"
                      >
                        <span
                          v-for="vital_sign in item.vital_signs"
                          :key="vital_sign.id"
                          class="vital-sign worksansr mb-0 pl-2"
                        >
                          <strong>{{ vital_sign.type }}:</strong>
                          {{ vital_sign.description }}
                          {{
                            vital_sign.type == "DOR"
                              ? `(${handleDescriptionAche(
                                  vital_sign.description
                                )})`
                              : vital_sign.abbreviation
                          }}
                          - (às {{ formatTime(vital_sign.created_at) }});
                        </span>
                        <br />
                        (Assinatura eletrônica)
                        {{
                          professionalClassCouncilValue({
                            id: item.user_professional_class_council_id,
                            name: item.user_name,
                            profile: item.user_profile_name,
                            cpf: item.user_cpf,
                            office: item.user_office,
                            value: item.user_professional_class_council_value,
                          })
                        }}
                        -
                        {{
                          moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                        }}
                      </div>
                      <hr class="mb-1 border-black" />
                    </div>
                    <!-- FECHA SINAIS VITAIS -->
                    <!-- ABRE ANOTAÇÃO -->
                    <div>
                      <div class="text-center"><strong>ANOTAÇÃO</strong></div>
                      <div
                        v-if="
                          care.shift_change.length > 0 &&
                          care.shift_change.find(
                            ({ beginning_or_end }) =>
                              beginning_or_end === 'INICIO'
                          )
                        "
                      >
                        <h6 class="mb-1 upper-text worksansr">
                          <strong class="mr-2"
                            >Assumo o plantão, cliente</strong
                          >
                          <span>{{ care.care.resident_name }}</span>
                          <strong class="mr-2 ml-2">no(a)</strong>
                          <span
                            v-for="(item, key) in care.shift_change"
                            :key="`${key}-${generateId()}`"
                            v-show="item.beginning_or_end == 'INICIO'"
                            >{{ item.place }}, {{ item.response }}</span
                          >.
                        </h6>
                      </div>
                      <div v-if="care.feeding_care.length > 0">
                        <h6 class="mb-1 upper-text worksansr">
                          <strong class="mr-2">Alimentação:</strong
                          ><span
                            class="upper-text"
                            v-for="(item, key) in care.feeding_care"
                            :key="`${key}-${generateId()}`"
                          >
                            {{ item.feeding_care_name }}:
                            {{ item.response }} ({{
                              formatDate(item.created_at)
                            }});
                          </span>
                        </h6>
                      </div>
                      <div v-if="care.bath.length > 0">
                        <h6 class="mb-1 upper-text worksansr">
                          <strong class="mr-2">Banho:</strong>
                          <span
                            class="upper-text"
                            v-for="(item, key) in care.bath"
                            :key="`${key}-${generateId()}`"
                            >Realizado o banho de {{ item.bath_type }} pela
                            {{ item.shift }} ({{
                              formatDate(item.created_at)
                            }});</span
                          >
                        </h6>
                      </div>
                      <div v-if="care.care.annotation">
                        <h6 class="mb-1 upper-text worksansr">
                          <span>{{ care.care.annotation }}</span>
                        </h6>
                      </div>
                      <div
                        v-if="
                          care.shift_change.length > 0 &&
                          care.shift_change.find(
                            ({ beginning_or_end }) => beginning_or_end === 'FIM'
                          )
                        "
                      >
                        <h6 class="mb-1 upper-text worksansr">
                          <strong class="mr-2"
                            >Encerro o plantão, cliente</strong
                          >
                          <span>{{ care.care.resident_name }}</span>
                          <strong class="ml-2 mr-2">no(a)</strong>
                          <span
                            class="upper-text"
                            v-for="(item, key) in care.shift_change"
                            :key="`${key}-${generateId()}`"
                            v-show="item.beginning_or_end == 'FIM'"
                            >{{ item.place }}, {{ item.response }}</span
                          >.
                        </h6>
                      </div>
                      <div
                        v-if="
                          care.shift_change.length > 0 &&
                          !care.shift_change.find(
                            ({ beginning_or_end }) => beginning_or_end === 'FIM'
                          )
                        "
                      >
                        <h6 class="mb-1 upper-text worksansr">
                          <strong class="mr-2"
                            >Encerro o plantão, cliente</strong
                          >
                          <span class="mr-2">{{ care.care.resident_name }}</span>
                          <span class="upper-text">{{
                            moment(care.care.updated_at).format(
                              "DD/MM/YYYY HH:mm:ss"
                            )
                          }}</span
                          >.
                        </h6>
                      </div>
                      (Assinatura eletrônica)
                      {{
                        professionalClassCouncilValue({
                          id: care.care.user_professional_class_council_id,
                          name: care.care.user_name,
                          cpf: care.care.user_cpf,
                          office: care.care.user_office,
                          value:
                            care.care.user_professional_class_council_value,
                        })
                      }}
                      -
                      {{
                        moment(care.care.updated_at).format(
                          "DD/MM/YYYY HH:mm:ss"
                        )
                      }}
                    </div>
                    <!-- FECHA ANOTAÇÃO -->
                  </div>
                  <!-- ABRE SINAIS VITAIS -->
                  <div
                    v-for="(item, key) in cares_vital_signs"
                    :key="`${key}-${generateId()}`"
                    class="border mb-3 mt-3 p-2"
                    style="page-break-inside: avoid !important"
                  >
                    <div
                      v-for="(item, key) in item.vital_signs"
                      :key="`${key}-${generateId()}`"
                    >
                      <span
                        v-for="vital_sign in item.vital_signs"
                        :key="vital_sign.id"
                        class="vital-sign worksansr mb-0 pl-2"
                      >
                        <strong>{{ vital_sign.type }}:</strong>
                        {{ vital_sign.description }}
                        {{
                          vital_sign.type == "DOR"
                            ? `(${handleDescriptionAche(
                                vital_sign.description
                              )})`
                            : vital_sign.abbreviation
                        }}
                        - (às {{ formatTime(vital_sign.created_at) }});
                      </span>
                      <br />
                      (Assinatura eletrônica)
                      {{
                        professionalClassCouncilValue({
                          id: item.user_professional_class_council_id,
                          name: item.user_name,
                          profile: item.user_profile_name,
                          cpf: item.user_cpf,
                          office: item.user_office,
                          value: item.user_professional_class_council_value,
                        })
                      }}
                      -
                      {{
                        moment(item.created_at).format("DD/MM/YYYY HH:mm:ss")
                      }}
                    </div>
                  </div>
                  <!-- FECHA SINAIS VITAIS -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <table v-if="type_report == 'synthetic'" class="table-synthetic">
          <thead>
            <tr>
              <td colspan="13">
                <div class="header-space">
                  <div v-if="resident.id" class="row">
                    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2">
                      <img
                        v-if="rest_home_logo_url"
                        class="rest_home_logo_url"
                        :src="rest_home_logo_url"
                      />
                      <div v-if="!rest_home_logo_url" class="ml-1">
                        <strong class="text-uppercase">{{
                          rest_home_name
                        }}</strong>
                      </div>
                    </div>
                    <div
                      class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-7 d-flex align-items-center"
                    >
                      <img
                        v-if="resident.photo_url"
                        class="resident_photo_url"
                        :src="resident.photo_url"
                      />
                      <img
                        v-if="!resident.photo_url"
                        class="resident_photo_url"
                        :src="require('../../../../../assets/user.png')"
                      />
                      <ResidentDataPrintDefault :resident_id="resident.id" />
                    </div>
                    <div
                      class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 d-flex align-items-center justify-content-end"
                    >
                      <img class="logo" :src="logo" width="180" />
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </thead>
          <thead>
            <tr>
              <th>FC</th>
              <th>FR</th>
              <th>PA</th>
              <th>GC</th>
              <th>SPO2</th>
              <th>TEMP</th>
              <th>DIURESE</th>
              <th>EVACUAÇÃO</th>
              <th>DOR</th>
              <th>PESO</th>
              <th>ALTURA</th>
              <th>USUÁRIO</th>
              <th>CADASTRADO</th>
              <th>HORA</th>
            </tr>
          </thead>
          <tbody
            v-for="(item, key) in cares_vital_signs"
            :key="`${key}-${generateId()}`"
          >
            <tr
              v-for="(item, key) in item.vital_signs"
              :key="`${key}-${generateId()}`"
              style="page-break-inside: avoid !important"
            >
              <td>
                {{ handleTypeByType(item, "PULSO (FREQUÊNCIA CARDÍACA)") }}
              </td>
              <td>
                {{ handleTypeByType(item, "FREQUÊNCIA RESPIRATÓRIA") }}
              </td>
              <td>
                {{ handleTypeByType(item, "PRESSÃO ARTERIAL") }}
              </td>
              <td>
                {{ handleTypeByType(item, "GLICEMIA CAPILAR") }}
              </td>
              <td>
                {{ handleTypeByType(item, "SATURAÇÃO DE OXIGÊNIO") }}
              </td>
              <td>
                {{ handleTypeByType(item, "TEMPERATURA CORPORAL") }}
              </td>
              <td>
                {{ handleTypeByType(item, "DIURESE") }}
              </td>
              <td>
                {{ handleTypeByType(item, "EVACUAÇÃO") }}
              </td>
              <td>
                {{ handleTypeByType(item, "DOR") }}
              </td>
              <td>
                {{ handleTypeByType(item, "PESO") }}
              </td>
              <td>
                {{ handleTypeByType(item, "ALTURA") }}
              </td>
              <td>
                {{ item.user_name }}
              </td>
              <td>
                {{ moment(item.created_at).format("DD/MM/YYYY") }}
              </td>
              <td>
                {{ moment(item.created_at).format("HH:mm:ss") }}
              </td>
            </tr>
          </tbody>
        </table>

        <div class="text-right">
          <v-btn v-if="!loading" class="btn-print" v-on:click="printOut"
            ><i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
          >
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintDefault from "../../../../../components/resident/ResidentDataPrintDefault";

import ErrorsMessages from "../../../../Components/ErrorsMessages";

import api from "../../../../../services/api";

import {
  generateId,
  formatDate,
  formatTime,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import routes from "../../../../../routes";

import { userData } from "../../../../../lib/functions";

import { getAge } from "../../../../../lib/getAgeByDate";

import moment from "moment";

export default {
  name: "Report",

  components: {
    ResidentDataPrintDefault,
    ErrorsMessages,
  },

  data() {
    return {
      id: "",
      errors: [],
      resident_id: "",
      type_report: "analytical",
      care_ids: [],
      vital_sign_ids: [],
      cares: [],
      cares_vital_signs: [],
      resident: {},
      rest_home_name: "",
      rest_home_fantasy_name: "",
      rest_home_logo_url: null,
      logo: null,
      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    getAge,
    moment,
    generateId,
    formatDate,
    formatTime,
    professionalClassCouncilValue,

    handleTypeByType(item, type) {
      if (item.vital_signs) {
        for (let vital_signs of item.vital_signs) {
          if (type == vital_signs.type) {
            if (vital_signs.type == "DOR") {
              return `${
                vital_signs.description
                  ? this.handleDescriptionAche(vital_signs.description)
                  : "--"
              }`;
            } else {
              return `${
                vital_signs.description ? vital_signs.description : "--"
              }`;
            }
          }
        }
      }

      return `--`;
    },

    handleDescriptionAche(nivel) {
      if (parseInt(nivel) == 0 || !nivel) {
        return "SEM DOR";
      } else if (parseInt(nivel) >= 1 && parseInt(nivel) <= 3) {
        return "DOR LEVE";
      } else if (parseInt(nivel) >= 4 && parseInt(nivel) <= 7) {
        return "DOR MODERADA";
      } else if (parseInt(nivel) >= 8 && parseInt(nivel) <= 10) {
        return "DOR INTENSA";
      }
    },

    async retrieve() {
      const { resident_id, care_ids, vital_sign_ids, type_report } =
        routes.history.current.params;

      const { user, logo } = userData();

      this.rest_home_name = user.rest_home_name;
      this.rest_home_fantasy_name = user.rest_home_fantasy_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      this.resident_id = resident_id;
      this.type_report = type_report;

      if (care_ids != "false") {
        this.care_ids = care_ids.split(",");
      }

      if (vital_sign_ids != "false") {
        this.vital_sign_ids = vital_sign_ids.split(",");
      }

      await this.get();
    },

    async get() {
      try {
        this.loading = true;

        const { resident_id, care_ids, vital_sign_ids, type_report } = this;

        var params = { resident_id, care_ids, vital_sign_ids, type_report };

        const response = await api.get("/rest-home/report/annotation/report", {
          params,
        });

        const { error, errors, resident, cares, cares_vital_signs } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.resident = resident;
          this.cares = cares;
          this.cares_vital_signs = cares_vital_signs;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    printOut() {
      window.print();
    },
  },
};
</script>

<style>
.pdf-report-care .header,
.pdf-report-care .header-space {
  height: auto;
}

.pdf-report-care .header {
  position: fixed;
  top: 0;
}

.pdf-report-care .logo {
  height: 50px;
  object-fit: contain;
}

.pdf-report-care .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}

.pdf-report-care .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  object-fit: cover;
}

.pdf-report-care .table,
.pdf-report-care .table td,
.pdf-report-care .table th,
.pdf-report-care .table tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

.pdf-report-care .table-synthetic {
  width: 100% !important;
  cursor: auto !important;
}

.pdf-report-care .table-synthetic,
.pdf-report-care .table-synthetic td,
.pdf-report-care .table-synthetic th,
.pdf-report-care .table-synthetic tfoot {
  border: 1px #000;
  border-style: double;
  padding: 2px;
}

.pdf-report-care .signature {
  width: 100%;
  margin-top: 12px;
  border-top: solid 1px #000;
}

.pdf-report-care th {
  background-color: #f5f5f5;
}

.pdf-report-care tr span {
  font-size: 15px;
}

.pdf-report-care caption {
  font-size: x-large;
}

@media print {
  .pdf-report-care table {
    width: 100% !important;
    border: none !important;
    margin-top: 10px !important;
  }

  .pdf-report-care .content {
    page-break-inside: avoid !important;
  }

  .pdf-report-care .content .care {
    page-break-inside: avoid !important;
  }

  * {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }

  body {
    margin: 0 !important;
    padding: 0 !important;
    line-height: 1.4em !important;
  }

  .pdf-report-care button {
    display: none;
  }
}
</style>
